import { X } from "lucide-react";
import { useToastStore } from "../stores/toastStore";

export function ToastViewport() {
  const toasts = useToastStore((state) => state.toasts);
  const dismiss = useToastStore((state) => state.dismiss);
  return <aside className="toast-viewport" aria-live="polite" aria-label="通知">
    {toasts.map((toast) => <div key={toast.id} className={`app-toast ${toast.tone}`} role={toast.tone === "error" ? "alert" : "status"}>
      <span>{toast.message}</span><button aria-label="关闭通知" onClick={() => dismiss(toast.id)}><X size={15}/></button>
    </div>)}
  </aside>;
}
